"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_request_1 = require("graphql-request");

var framework_1 = require("../../core/framework");

var Repository =
/** @class */
function (_super) {
  __extends(Repository, _super);

  function Repository(baseUrl, authorization) {
    var _this = _super.call(this, baseUrl) || this;

    _this.setHeader("authorization", authorization);

    return _this;
  }

  Repository.prototype.getCartId = function () {
    return this.request(graphql_request_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query {\n          marketMe {\n            user {\n              cart {\n                id\n              }\n            }\n          }\n        }\n      "], ["\n        query {\n          marketMe {\n            user {\n              cart {\n                id\n              }\n            }\n          }\n        }\n      "]))));
  };

  Repository.prototype.getUser = function () {
    return this.request(graphql_request_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        query {\n          marketMe {\n            user {\n              id\n              firstName\n              lastName\n              email\n              phone\n              dob\n              cart {\n                id\n                totalPrice\n                subtotalPrice\n                originSubtotalPrice\n                discount\n                promotions {\n                  banner\n                  discount\n                }\n                skus {\n                  skuId\n                  quantity\n                  price\n                  originPrice\n                  discount\n                  sku {\n                    product {\n                      imageUrl\n                      name\n                    }\n                  }\n                }\n                taxes {\n                  amount\n                  tax {\n                    name\n                  }\n                }\n                depotId\n              }\n            }\n          }\n        }\n      "], ["\n        query {\n          marketMe {\n            user {\n              id\n              firstName\n              lastName\n              email\n              phone\n              dob\n              cart {\n                id\n                totalPrice\n                subtotalPrice\n                originSubtotalPrice\n                discount\n                promotions {\n                  banner\n                  discount\n                }\n                skus {\n                  skuId\n                  quantity\n                  price\n                  originPrice\n                  discount\n                  sku {\n                    product {\n                      imageUrl\n                      name\n                    }\n                  }\n                }\n                taxes {\n                  amount\n                  tax {\n                    name\n                  }\n                }\n                depotId\n              }\n            }\n          }\n        }\n      "]))));
  };

  Repository.prototype.updateProfile = function (phone, firstName, lastName, dob, email, residence) {
    return this.request(graphql_request_1.gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        mutation ProfileUpdate($input: MarketUserInfoInput!) {\n          marketUpdateMe(input: $input) {\n            user {\n              id\n              firstName\n              lastName\n              dob\n              email\n              phone\n            }\n          }\n        }\n      "], ["\n        mutation ProfileUpdate($input: MarketUserInfoInput!) {\n          marketUpdateMe(input: $input) {\n            user {\n              id\n              firstName\n              lastName\n              dob\n              email\n              phone\n            }\n          }\n        }\n      "]))), {
      input: {
        phone: phone,
        firstName: firstName,
        lastName: lastName,
        dob: dob,
        email: email || null,
        residence: residence || []
      }
    });
  };

  Repository.prototype.saveUserDocument = function (fileId, fileUrl, type) {
    return this.request(graphql_request_1.gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        mutation SaveUserDocument($input: SaveUserDocumentInput!) {\n          saveUserDocument(input: $input) {\n            user {\n              id\n            }\n          }\n        }\n      "], ["\n        mutation SaveUserDocument($input: SaveUserDocumentInput!) {\n          saveUserDocument(input: $input) {\n            user {\n              id\n            }\n          }\n        }\n      "]))), {
      input: {
        documents: [{
          fileId: fileId,
          fileUrl: fileUrl,
          type: type,
          expirationDate: new Date(2099, 0, 1)
        }]
      }
    });
  };

  return Repository;
}(framework_1.RepositoryBase);

exports.default = Repository;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;